var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('label',{staticClass:"editor-label"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_c('editor',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"api-key":"u5934q5w5s81yyj7imd6h87byzeqk2g4822lwkd4unf4lhkc","init":{
      height: _vm.height,
      width: _vm.width,
      menubar: _vm.menubar,
      branding: _vm.branding,
      statusbar: _vm.statusbar,
      resize: _vm.resize,
      plugins: _vm.plugins,
      skin: _vm.skin,
      icons: _vm.icons,
      toolbar_location: _vm.toolbar_location,
      toolbar: _vm.toolbar,
      content_style: '.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {color: rgba(96, 96, 96, 0.87);}'
    }},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }